const locale = {
  submit: '提交',
  cancel: '取消',
  complete: '完成',
  next: '下一步',
  addText: '添加',
  deleteText: '删除'
};

export default locale;
